
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { Modal, Button } from "react-bootstrap";
import ReportModalContent from "./ReportModalContent";
import "./Reports.css";
import { Card, CardBody, CardTitle } from "reactstrap";
import Navbar from "../../Shared/Navbar";

import { baseUrl } from "./../../Apiurls/Apiurls";
import { useContext } from "react";
import { AuthContext } from "./../../Contextapi/ContextApi";

const Report = () => {
  const { logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [formDataList, setFormDataList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [filters, setFilters] = useState({
    name: "",
    age: "",
    gender: "",
    contactNo: "",
    location: "",
    educationQualification: "",
    organisation: "",
    designation: "",
    email: "",
    totalExperience: "",
    positionsSuitableFor: "",
    skills: "",
    noticePeriod: "",
    assessment: "",
    fmcgSalesExp: "",
    pedigree: "",
    shortlist: "",
    source: "",
    sharedOn: "",
    consultant: "",
    payroll: "",
    tradeHandled: "",
    businessVolume: "",
    geographyCovered: "",
    nativePlace: "",
    distributorsHandled: "",
    productsHandled: "",
    accountsRetailCounters: "",
    teamSize: "",
    reportingTo: "",
    monthlyTurnover: "",
    currentTotalCTC: "",
    currentFixedCTC: "",
    currentVariableCTC: "",
    ctcIncreasePercentage: "",
    ctcType: "",
    calculatedCTC: "",
    reasonForChange: "",
    languagesKnown: "",
    itLanguagesKnown: "",
    databasesKnown: "",
    softwareKnown: "",
    additionalSkills: "",
    linkedinProfile: "",
    comments: "",
    isNoticePeriodNegotiable: "",
  });

  const [columnVisibility, setColumnVisibility] = useState({
    name: false,
    age: false,
    gender: false,
    contactNo: false,
    location: false,
    educationQualification: false,
    organisation: false,
    designation: false,
    email: false,
    totalExperience: false,
    positionsSuitableFor: false,
    skills: false,
    noticePeriod: false,
    assessment: false,
    fmcgSalesExp: false,
    pedigree: false,
    shortlist: false,
    source: false,
    sharedOn: false,
    consultant: false,
    payroll: false,
    tradeHandled: false,
    businessVolume: false,
    geographyCovered: false,
    nativePlace: false,
    distributorsHandled: false,
    productsHandled: false,
    accountsRetailCounters: false,
    teamSize: false,
    reportingTo: false,
    monthlyTurnover: false,
    currentTotalCTC: false,
    currentFixedCTC: false,
    currentVariableCTC: false,
    ctcIncreasePercentage: false,
    ctcType: false,
    calculatedCTC: false,
    reasonForChange: false,
    languagesKnown: false,
    itLanguagesKnown: false,
    databasesKnown: false,
    softwareKnown: false,
    additionalSkills: false,
    linkedinProfile: false,
    comments: false,
    isNoticePeriodNegotiable: false,
  });

  const toggleColumnVisibility = (columnName) => {
    setColumnVisibility((prevVisibility) => ({
      ...prevVisibility,
      [columnName]: !prevVisibility[columnName],
    }));
  };

  const clearFilters = () => {
    setFilters({
      name: "",
      age: "",
      gender: "",
      contactNo: "",
      location: "",
      educationQualification: "",
      organisation: "",
      designation: "",
      email: "",
      totalExperience: "",
      positionsSuitableFor: "",
      skills: "",
      noticePeriod: "",
      assessment: "",
      fmcgSalesExp: "",
      pedigree: "",
      shortlist: "",
      source: "",
      sharedOn: "",
      consultant: "",
      payroll: "",
      tradeHandled: "",
      businessVolume: "",
      geographyCovered: "",
      nativePlace: "",
      distributorsHandled: "",
      productsHandled: "",
      accountsRetailCounters: "",
      teamSize: "",
      reportingTo: "",
      monthlyTurnover: "",
      currentTotalCTC: "",
      currentFixedCTC: "",
      currentVariableCTC: "",
      ctcIncreasePercentage: "",
      ctcType: "",
      calculatedCTC: "",
      reasonForChange: "",
      languagesKnown: "",
      itLanguagesKnown: "",
      databasesKnown: "",
      softwareKnown: "",
      additionalSkills: "",
      linkedinProfile: "",
      comments: "",
      isNoticePeriodNegotiable: "",
    });
    setSearchTerm("");
  };

  const handleModalSubmit = () => {
    const selectedColumns = Object.keys(columnVisibility).filter(
      (columnName) => columnVisibility[columnName]
    );

    if (selectedColumns.length === 0) {
      alert("Please select at least one column before submitting.");
    } else {
      setShowModal(true);
    }
  };

  const handleLogout = () => {
    logout();
    alert("You have successfully logged out");
    navigate("/");
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleClose = () => {
    setShowModal(false);
  };
  const fetchData = async () => {
  try {
    const response = await fetch(`${baseUrl}/api/tracker`); // GET all data API
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const formDataArray = await response.json();

    // Sort the data alphabetically by the 'name' field
    formDataArray.sort((a, b) =>
      a.name.localeCompare(b.name, "en", { sensitivity: "base" })
    );

    setFormDataList(formDataArray);
    console.log("formDataList", formDataArray);
  } catch (error) {
    console.error("Error fetching data:", error);
  }
};

  const handleNavigation = (path) => {
    navigate(path);
  };

  const handleCheckboxChange = (id) => {
    const updatedFormDataList = formDataList.map((formData) => {
      if (formData.id === id) {
        return { ...formData, selected: !formData.selected };
      }
      return formData;
    });
    setFormDataList(updatedFormDataList);
  };

  const columnHeaderLabels = {
    name: "Name",
    age: "Age",
    gender: "Gender",
    contactNo: "Contact Number",
    location: "Location",
    educationQualification: "Education Qualification",
    organisation: "Organization",
    designation: "Designation",
    email: "Email",
    totalExperience: "Total Experience",
    positionsSuitableFor: "Positions Suitable For",
    skills: "Skills",
    noticePeriod: "Notice Period",
    assessment: "Assessment",
    fmcgSalesExp: "FMCG Sales Experience",
    pedigree: "Pedigree",
    shortlist: "Shortlist",
    source: "Source",
    sharedOn: "Shared On",
    consultant: "Consultant",
    payroll: "Payroll",
    tradeHandled: "Trade Handled",
    businessVolume: "Business Volume",
    geographyCovered: "Geography Covered",
    nativePlace: "Native Place",
    distributorsHandled: "Distributors Handled",
    productsHandled: "Products Handled",
    accountsRetailCounters: "Accounts Retail Counters",
    teamSize: "Team Size",
    reportingTo: "Reporting To",
    monthlyTurnover: "Monthly Turnover",
    currentTotalCTC: "Current Total CTC",
    currentFixedCTC: "Current Fixed CTC",
    currentVariableCTC: "Current Variable CTC",
    ctcIncreasePercentage: "CTC Increase Percentage",
    ctcType: "CTC Type",
    calculatedCTC: "Expected CTC",
    reasonForChange: "Reason For Change",
    languagesKnown: "Languages Known",
    itLanguagesKnown: "IT Languages Known",
    databasesKnown: "Databases Known",
    softwareKnown: "Software Known",
    additionalSkills: "Additional Skills",
    linkedinProfile: "LinkedIn Profile",
    comments: "Comments",
    isNoticePeriodNegotiable: "Is Notice Period Negotiable",
  };

  const renderColumnHeader = (columnName) => {
    const label = columnHeaderLabels[columnName];
    return (
      <div key={columnName} className="col-6">
        <label>
          <input
            type="checkbox"
            checked={columnVisibility[columnName]}
            onChange={() => toggleColumnVisibility(columnName)}
          />
          &nbsp;{label}
        </label>
      </div>
    );
  };

  const renderSelectedColumns = () => {
    return Object.keys(columnVisibility).map((columnName) => {
      if (columnVisibility[columnName]) {
        const label = columnHeaderLabels[columnName];
        return (
          <div key={columnName} className="col-6 pb-0">
            <p className="mb-1">{label}</p>
          </div>
        );
      }
      return null;
    });
  };

  const filteredData = formDataList.filter((formData) => {
    console.log("formData.calculatedCTC:", typeof formData.calculatedCTC);
    console.log("formData.age:", typeof formData.age);
    formData.calculatedCTC = String(formData.calculatedCTC);
    formData.currentTotalCTC = String(formData.currentTotalCTC);
    formData.currentVariableCTC = String(formData.currentVariableCTC);

    formData.currentFixedCTC = String(formData.currentFixedCTC);
    formData.ctcIncreasePercentage = String(formData.ctcIncreasePercentage);
    return (
      (!filters.name ||
        (formData.name &&
          formData.name.toLowerCase().includes(filters.name.toLowerCase()))) &&
      (!filters.age || (formData.age && formData.age.includes(filters.age))) &&
      (!filters.gender ||
        (formData.gender &&
          formData.gender
            .toLowerCase()
            .includes(filters.gender.toLowerCase()))) &&
      (!filters.contactNo ||
        (formData.contactNo &&
          formData.contactNo.includes(filters.contactNo))) &&
      (!filters.location ||
        (formData.location &&
          formData.location
            .toLowerCase()
            .includes(filters.location.toLowerCase()))) &&
      (!filters.educationQualification ||
        (formData.educationQualification &&
          formData.educationQualification
            .toLowerCase()
            .includes(filters.educationQualification.toLowerCase()))) &&
      (!filters.organisation ||
        (formData.organisation &&
          formData.organisation
            .toLowerCase()
            .includes(filters.organisation.toLowerCase()))) &&
      (!filters.designation ||
        (formData.designation &&
          formData.designation
            .toLowerCase()
            .includes(filters.designation.toLowerCase()))) &&
      (!filters.email ||
        (formData.email &&
          formData.email
            .toLowerCase()
            .includes(filters.email.toLowerCase()))) &&
      (!filters.positionsSuitableFor ||
        (formData.positionsSuitableFor &&
          formData.positionsSuitableFor
            .toLowerCase()
            .includes(filters.positionsSuitableFor.toLowerCase()))) &&
      (!filters.skills ||
        (formData.skills &&
          formData.skills
            .toLowerCase()
            .includes(filters.skills.toLowerCase()))) &&
      (!filters.noticePeriod ||
        (formData.noticePeriod &&
          formData.noticePeriod.includes(
            filters.noticePeriod.toLowerCase()
          ))) &&
      (!filters.assessment ||
        (formData.assessment &&
          formData.assessment.includes(filters.assessment.toLowerCase()))) &&
      (!filters.fmcgSalesExp ||
        (formData.fmcgSalesExp &&
          formData.fmcgSalesExp.includes(
            filters.fmcgSalesExp.toLowerCase()
          ))) &&
      (!filters.pedigree ||
        (formData.pedigree &&
          formData.pedigree.includes(filters.pedigree.toLowerCase()))) &&
      (!filters.shortlist ||
        (formData.shortlist &&
          formData.shortlist.includes(filters.shortlist.toLowerCase()))) &&
      (!filters.source ||
        (formData.source &&
          formData.source.includes(filters.source.toLowerCase()))) &&
      (!filters.sharedOn ||
        (formData.sharedOn &&
          formData.sharedOn.includes(filters.sharedOn.toLowerCase()))) &&
      (!filters.consultant ||
        (formData.consultant &&
          formData.consultant.includes(filters.consultant.toLowerCase()))) &&
      (!filters.payroll ||
        (formData.payroll &&
          formData.payroll.includes(filters.payroll.toLowerCase()))) &&
      (!filters.tradeHandled ||
        (formData.tradeHandled &&
          formData.tradeHandled.includes(
            filters.tradeHandled.toLowerCase()
          ))) &&
      (!filters.businessVolume ||
        (formData.businessVolume &&
          formData.businessVolume.includes(
            filters.businessVolume.toLowerCase()
          ))) &&
      (!filters.geographyCovered ||
        (formData.geographyCovered &&
          formData.geographyCovered.includes(
            filters.geographyCovered.toLowerCase()
          ))) &&
      (!filters.nativePlace ||
        (formData.nativePlace &&
          formData.nativePlace.includes(filters.nativePlace.toLowerCase()))) &&
      (!filters.distributorsHandled ||
        (formData.distributorsHandled &&
          formData.distributorsHandled.includes(
            filters.distributorsHandled.toLowerCase()
          ))) &&
      (!filters.productsHandled ||
        (formData.productsHandled &&
          formData.productsHandled.includes(
            filters.productsHandled.toLowerCase()
          ))) &&
      (!filters.accountsRetailCounters ||
        (formData.accountsRetailCounters &&
          formData.accountsRetailCounters.includes(
            filters.accountsRetailCounters.toLowerCase()
          ))) &&
      (!filters.teamSize ||
        (formData.teamSize &&
          formData.teamSize.includes(filters.teamSize.toLowerCase()))) &&
      (!filters.reportingTo ||
        (formData.reportingTo &&
          formData.reportingTo.includes(filters.reportingTo.toLowerCase()))) &&
      (!filters.monthlyTurnover ||
        (formData.monthlyTurnover &&
          formData.monthlyTurnover.includes(
            filters.monthlyTurnover.toLowerCase()
          ))) &&
      (!filters.currentTotalCTC ||
        (formData.currentTotalCTC &&
          formData.currentTotalCTC.includes(filters.currentTotalCTC))) &&
      (!filters.currentFixedCTC ||
        (formData.currentFixedCTC &&
          formData.currentFixedCTC.includes(filters.currentFixedCTC))) &&
      (!filters.currentVariableCTC ||
        (formData.currentVariableCTC &&
          formData.currentVariableCTC.includes(filters.currentVariableCTC))) &&
      (!filters.ctcType ||
        (formData.ctcType &&
          formData.ctcType.includes(filters.ctcType.toLowerCase()))) &&
      (!filters.calculatedCTC ||
        (formData.calculatedCTC !== undefined &&
          typeof formData.calculatedCTC === "string" &&
          filters.calculatedCTC !== undefined &&
          typeof filters.calculatedCTC === "string" &&
          formData.calculatedCTC
            .toLowerCase()
            .includes(filters.calculatedCTC.toLowerCase()))) &&
      (!filters.reasonForChange ||
        (formData.reasonForChange &&
          formData.reasonForChange.includes(
            filters.reasonForChange.toLowerCase()
          ))) &&
      (!filters.languagesKnown ||
        (formData.languagesKnown &&
          formData.languagesKnown.includes(
            filters.languagesKnown.toLowerCase()
          ))) &&
      (!filters.itLanguagesKnown ||
        (formData.itLanguagesKnown &&
          formData.itLanguagesKnown.includes(
            filters.itLanguagesKnown.toLowerCase()
          ))) &&
      (!filters.databasesKnown ||
        (formData.databasesKnown &&
          formData.databasesKnown.includes(
            filters.databasesKnown.toLowerCase()
          ))) &&
      (!filters.softwareKnown ||
        (formData.softwareKnown &&
          formData.softwareKnown.includes(
            filters.softwareKnown.toLowerCase()
          ))) &&
      (!filters.additionalSkills ||
        (formData.additionalSkills &&
          formData.additionalSkills.includes(
            filters.additionalSkills.toLowerCase()
          ))) &&
      (!filters.linkedinProfile ||
        (formData.linkedinProfile &&
          formData.linkedinProfile.includes(
            filters.linkedinProfile.toLowerCase()
          ))) &&
      (!filters.comments ||
        (formData.comments &&
          formData.comments.includes(filters.comments.toLowerCase()))) &&
      (!filters.isNoticePeriodNegotiable ||
        (formData.isNoticePeriodNegotiable &&
          formData.isNoticePeriodNegotiable.includes(
            filters.isNoticePeriodNegotiable.toLowerCase()
          ))) &&
      (formData.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        formData.age.includes(searchTerm) ||
        (formData.gender &&
          formData.gender.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (formData.contactNo && formData.contactNo.includes(searchTerm)) ||
        (formData.location &&
          formData.location.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (formData.educationQualification &&
          formData.educationQualification
            .toLowerCase()
            .includes(searchTerm.toLowerCase())) ||
        (formData.organisation &&
          formData.organisation
            .toLowerCase()
            .includes(searchTerm.toLowerCase())) ||
        (formData.designation &&
          formData.designation
            .toLowerCase()
            .includes(searchTerm.toLowerCase())) ||
        (formData.email &&
          formData.email.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (formData.totalExperience &&
          formData.totalExperience
            .toLowerCase()
            .includes(searchTerm.toLowerCase())) ||
        (formData.positionsSuitableFor &&
          formData.positionsSuitableFor
            .toLowerCase()
            .includes(searchTerm.toLowerCase())) ||
        (formData.skills &&
          formData.skills.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (formData.noticePeriod &&
          formData.noticePeriod.includes(searchTerm.toLowerCase())) ||
        (formData.assessment &&
          formData.assessment.includes(searchTerm.toLowerCase())) ||
        (formData.fmcgSalesExp &&
          formData.fmcgSalesExp.includes(searchTerm.toLowerCase())) ||
        (formData.pedigree &&
          formData.pedigree.includes(searchTerm.toLowerCase())) ||
        (formData.shortlist &&
          formData.shortlist.includes(searchTerm.toLowerCase())) ||
        (formData.source &&
          formData.source.includes(searchTerm.toLowerCase())) ||
        (formData.sharedOn &&
          formData.sharedOn.includes(searchTerm.toLowerCase())) ||
        (formData.consultant &&
          formData.consultant.includes(searchTerm.toLowerCase())) ||
        (formData.payroll &&
          formData.payroll.includes(searchTerm.toLowerCase())) ||
        (formData.tradeHandled &&
          formData.tradeHandled.includes(searchTerm.toLowerCase())) ||
        (formData.businessVolume &&
          formData.businessVolume.includes(searchTerm.toLowerCase())) ||
        (formData.geographyCovered &&
          formData.geographyCovered.includes(searchTerm.toLowerCase())) ||
        (formData.nativePlace &&
          formData.nativePlace.includes(searchTerm.toLowerCase())) ||
        (formData.distributorsHandled &&
          formData.distributorsHandled.includes(searchTerm.toLowerCase())) ||
        (formData.productsHandled &&
          formData.productsHandled.includes(searchTerm.toLowerCase())) ||
        (formData.accountsRetailCounters &&
          formData.accountsRetailCounters.includes(searchTerm.toLowerCase())) ||
        (formData.teamSize &&
          formData.teamSize.includes(searchTerm.toLowerCase())) ||
        (formData.reportingTo &&
          formData.reportingTo.includes(searchTerm.toLowerCase())) ||
        (formData.monthlyTurnover &&
          formData.monthlyTurnover.includes(searchTerm.toLowerCase())) ||
        // (formData.currentTotalCTC && formData.currentTotalCTC.includes(searchTerm.toLowerCase())) ||
        (formData.currentTotalCTC &&
          formData.currentTotalCTC.includes(searchTerm)) ||
        (formData.currentFixedCTC &&
          formData.currentFixedCTC.includes(searchTerm)) ||
        (formData.currentVariableCTC &&
          formData.currentVariableCTC.includes(searchTerm)) ||
        (formData.ctcIncreasePercentage &&
          formData.ctcIncreasePercentage.includes(searchTerm)) ||
        (formData.ctcType &&
          formData.ctcType.includes(searchTerm.toLowerCase())) ||
        (formData.calculatedCTC &&
          formData.calculatedCTC.includes(searchTerm)) ||
        (formData.reasonForChange &&
          formData.reasonForChange.includes(searchTerm.toLowerCase())) ||
        (formData.languagesKnown &&
          formData.languagesKnown.includes(searchTerm.toLowerCase())) ||
        (formData.itLanguagesKnown &&
          formData.itLanguagesKnown.includes(searchTerm.toLowerCase())) ||
        (formData.databasesKnown &&
          formData.databasesKnown.includes(searchTerm.toLowerCase())) ||
        (formData.softwareKnown &&
          formData.softwareKnown.includes(searchTerm.toLowerCase())) ||
        (formData.additionalSkills &&
          formData.additionalSkills.includes(searchTerm.toLowerCase())) ||
        (formData.linkedinProfile &&
          formData.linkedinProfile.includes(searchTerm.toLowerCase())) ||
        (formData.comments &&
          formData.comments.includes(searchTerm.toLowerCase())) ||
        (formData.isNoticePeriodNegotiable &&
          formData.isNoticePeriodNegotiable.includes(searchTerm.toLowerCase())))
    );
  });

  const dataForCurrentPage = filteredData;

  const calculateStartingSerialNumber = (page) => {
    return (page - 1) * dataForCurrentPage.length + 1;
  };

  const clearAll = () => {
    const clearedFormDataList = formDataList.map((formData) => ({
      ...formData,
      selected: false,
    }));
    setFormDataList(clearedFormDataList);

    const clearedColumnVisibility = { ...columnVisibility };
    Object.keys(clearedColumnVisibility).forEach((columnName) => {
      clearedColumnVisibility[columnName] = false;
    });
    setColumnVisibility(clearedColumnVisibility);
  };

  return (
    <>
  
        <div className="container-fluid mt-5">
          <div className="row">
            <div className="col-md-2">
              <Navbar/>
            </div>
            <div className="col-md-10">
              <div className="container mt-5">
                <h2 className="text-center mb-4">Report</h2>
                <div className="row mb-3">
                  <Card className="col-md-5 border border-dark">
                    <CardBody>
                      <CardTitle tag="h4" className="text-center mt-2">
                        Fields
                      </CardTitle>
                      <div className="row mt-5">
                        {Object.keys(columnVisibility).map(renderColumnHeader)}
                      </div>
                    </CardBody>
                  </Card>

                  <div className="col-md-1"></div>

                  <div className="col-md-5 border border-dark">
                    <div className="column-selection">
                      <h4 className="mt-2 mb-3">Selected Columns</h4>
                      <div className="row">{renderSelectedColumns()}</div>
                    </div>

                    <div className="mt-2 mb-2">
                      <button
                        className="btn btn-secondary"
                        onClick={handleModalSubmit}
                      >
                        Submit
                      </button>
                      &nbsp;&nbsp;
                      <button className="btn btn-secondary" onClick={clearAll}>
                        Clear All
                      </button>
                      <Modal
                        show={showModal}
                        onHide={handleClose}
                        size="lg"
                        dialogClassName="full-page-modal"
                      >
                        <Modal.Header closeButton>
                          <Modal.Title>Report Table</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <ReportModalContent
                            filters={filters}
                            setFilters={setFilters}
                            filteredData={dataForCurrentPage}
                            columnVisibility={columnVisibility}
                            handleCheckboxChange={handleCheckboxChange}
                            clearFilters={clearFilters}
                            startingSerialNumber={calculateStartingSerialNumber(
                              currentPage
                            )}
                            currentPage={currentPage}
                          />
                        </Modal.Body>
                        <Modal.Footer>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <Button variant="secondary" onClick={handleClose}>
                              Close
                            </Button>
                          </div>
                        </Modal.Footer>
                      </Modal>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    
    </>
  );
};

export default Report;
